<template>
  <div v-if="!canGetListOfUsers">
    Brak uprawnień
  </div>
  <div class="content" v-else>
    <spinner v-if="loading" />
    <div class="md-layout" v-else>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>people</md-icon>
            </div>
            <div class="btn-container">
              <md-button class="add-user-btn md-info" @click="show = true"
                >Dodaj użytkownika
              </md-button>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="usersAll"
              table-header-color="green"
              :md-sort="usersAll.name"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Imię" md-sort-by="name"
                  >{{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Nazwisko" md-sort-by="name"
                  >{{ item.surname }}
                </md-table-cell>
                <md-table-cell
                  md-label="Szablon"
                  v-if="
                    userRole.roleName === 'Admin' ||
                      userRole.roleName === 'adminYellows'
                  "
                  >{{ item.project }}
                </md-table-cell>
                <md-table-cell md-label="Email" md-sort-by="email"
                  >{{ item.email }}
                </md-table-cell>
                <md-table-cell md-label="Rola">
                  <md-field v-if="canCreateRole">
                    <md-select
                      v-model="item.role"
                      @md-selected="changeRole(item.id, item.role)"
                    >
                      <md-option
                        v-for="role in roles"
                        :key="role.id + role.roleName"
                        :value="role.id"
                      >
                        {{ role.roleName }}
                      </md-option>
                    </md-select>
                  </md-field>
                  <div v-else>
                    {{ item.role | role(roles) }}
                  </div>
                </md-table-cell>
                <md-table-cell md-label="Status">
                  <md-field v-if="canChangeUserStatus">
                    <md-select
                      v-model="item.status"
                      @md-selected="changeStatus(item.id, item.status)"
                    >
                      <md-option
                        v-for="status in userStatuses"
                        :key="status.userStatusId + status.name"
                        :value="status.userStatusId"
                      >
                        {{ status.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                  <div v-else>
                    {{ item.status | status(userStatuses) }}
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <Modal v-if="show">
      <template slot="header">
        <h4 class="modal-title">Rejestracja użytkownika</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="show = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <form>
          <md-field>
            <label>Imię</label>
            <md-input type="text" v-model="credentials.name" />
          </md-field>
          <md-field>
            <label>Nazwisko</label>
            <md-input type="text" v-model="credentials.surname" />
          </md-field>
          <md-field>
            <label>Email</label>
            <md-input type="email" v-model="credentials.email" />
          </md-field>
          <md-field v-if="canChangePdfTemplate">
            <label>Szablon</label>
            <md-select v-model="credentials.project">
              <md-option
                :value="project.idProject"
                v-for="project in projects"
                :key="project.idProject"
              >
                {{ project.name }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-if="userRole.roleName !== 'businessAdmin'">
            <label>Rola</label>
            <md-select v-model="credentials.role">
              <md-option
                :value="role.roleName"
                v-for="role in rolesForRegister"
                :key="role.id"
              >
                {{ role.roleName }}
              </md-option>
            </md-select>
          </md-field>
        </form>
      </template>
      <template slot="footer">
        <md-button class="md-info" @click="addUser()">
          Zarejestruj
        </md-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '../../components/Modal'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Users',
  components: { Modal },
  data() {
    return {
      loading: true,
      show: false,
      credentials: {
        name: '',
        surname: '',
        email: '',
        project: null,
        role: 'Seller',
      },
    }
  },
  created() {
    if (this.canGetListOfUsers) {
      this.setup()
    }
  },
  methods: {
    async setup() {
      await this.$store.dispatch('fetchUsers')
      await this.$store.dispatch('fetchUserStatuses')
      await this.$store.dispatch('fetchProjects')
      await this.$store.dispatch('fetchRolesForRegister')
      this.loading = false
    },
    changeRole(userId, roleId) {
      let roleName = this.$options.filters.role(roleId, this.roles)
      this.$store
        .dispatch('changeUserRole', {
          userId,
          roleName,
        })
        .then(() => this.$message('Rola została zmieniona'))
        .catch(error => this.$error(error.response.statusText))
    },
    changeStatus(userId, statusId) {
      this.$store
        .dispatch('changeUserStatus', {
          userId,
          statusId,
        })
        .then(() => this.$message('Status został pomyślnie zmieniony'))
        .catch(error => this.$error(error.response.statusText))
    },
    addUser() {
      this.$store
        .dispatch('addUser', {
          name: this.credentials.name.trim(),
          surname: this.credentials.surname.trim(),
          email: this.credentials.email,
          projectId: this.credentials.project,
          userRole: this.credentials.role,
        })
        .then(() => {
          this.show = false
          this.$message('Informacja została wysłana na email użytkownika')
        })
        .catch(error => {
          this.$error(error.response.data)
        })
    },
  },
  computed: {
    ...mapState({
      roles: state => state.user.roles,
    }),
    ...mapGetters([
      'userRole',
      'usersAll',
      'userStatuses',
      'canChangeUserStatus',
      'canGetListOfUsers',
      'canCreateRole',
      'projects',
      'rolesForRegister',
      'canChangePdfTemplate',
    ]),
  },
}
</script>

<style scoped>
.btn-container {
  text-align: right;
}

.add-user-btn {
  margin-top: 25px;
}
</style>
